var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheck03 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF4600",
  strokeLinejoin: "round",
  strokeWidth: 1.6,
  d: "m1.25 4.25 4.5 5 9-8.5"
})));
export default SvgIconCheck03;